import { render, staticRenderFns } from "./TicketFilesSummary.vue?vue&type=template&id=507484fc&"
import script from "./TicketFilesSummary.vue?vue&type=script&lang=js&"
export * from "./TicketFilesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports